import CryptoJS from 'crypto-js';

export default {
  data() {
    return {
      pageType: '',
      admin: false,
      amar: false,
      doctor: false,
      nurse: false,
      qc: false,
      followUp: false,
      dispather: false,
      admission: false,
      hospital: false,
      otherOrganization: false,
      dispatherEoc: false,
      dashboards: false,
      userRoleEnglishTitle: '',
      userRoleIdForLogin: '',
    };
  },
  methods: {
    loadFromLocalStorage_selectStateMission() {
      const saved = localStorage.getItem('selectMissonState');
      if (saved == "true") {
        this.$router.push({ name: 'currentMission800' });
        const routeData = this.$router.resolve({ name: 'newMissionWithMap800' });
        window.open(routeData.href, '_blank');
        return
      }
      const routeData = this.$router.resolve({ name: 'dispatchMap' });
      window.open(routeData.href, '_blank');
      this.$router.push({ name: 'mission800' });
    },
    goToProject: function (type) {
      if (type == 'admin') {
        let id = 1;
        id = id.toString();
        let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
        localStorage.setItem('dash', encryptId);
        this.$router.push({ name: 'user' });
      } else if (type == '800') {
        this.userRoleEnglishTitle = 'User800';
        this.userRoleIdForLogin = 2;
        let id = this.userRoleIdForLogin.toString();
        let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
        localStorage.setItem('dash', encryptId);
        this.setTheme('red');
        this.loadFromLocalStorage_selectStateMission()
        // const routeData = this.$router.resolve({ name: 'mission800' });
        // window.open(routeData.href, '_blank');
        // this.$router.push({ name: 'dispatchMap' });
      } else if (type == '115') {
        this.userRoleEnglishTitle = 'User115';
        this.userRoleIdForLogin = 3;
        let id = this.userRoleIdForLogin.toString();
        let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
        localStorage.setItem('dash', encryptId);
        this.$router.push({ name: 'mission115' });
      } else if (type == 'admission') {
        this.userRoleEnglishTitle = 'Admission';
        this.userRoleIdForLogin = 6;
        let id = this.userRoleIdForLogin.toString();
        let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
        localStorage.setItem('dash', encryptId);
        this.setTheme('red');
        this.$router.push({ name: 'admissionMap' });
        // const routeData = this.$router.resolve({ name: 'dashboardAdmission' });
        const routeData = this.$router.resolve({ name: 'admissionMissions' });
        window.open(routeData.href, '_blank');
      } else if (type == 'followUp') {
        this.userRoleEnglishTitle = 'FollowUp';
        this.userRoleIdForLogin = 7;
        let id = this.userRoleIdForLogin.toString();
        let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
        localStorage.setItem('dash', encryptId);
        this.setTheme('red');
        this.$router.push({ name: 'dashboardFollowUp' });
      } else if (type == 'doctor') {
        this.userRoleEnglishTitle = 'Doctor';
        this.userRoleIdForLogin = 8;
        let id = this.userRoleIdForLogin.toString();
        let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
        localStorage.setItem('dash', encryptId);
        this.setTheme('red');
        this.$router.push({ name: 'doctorDashboard' });
      } else if (type == 'hospital') {
        this.userRoleEnglishTitle = 'Hospital';
        this.userRoleIdForLogin = 9;
        let id = this.userRoleIdForLogin.toString();
        let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
        localStorage.setItem('dash', encryptId);
        this.setTheme('red');
        this.$router.push({ name: 'hospitalMissions' });
      } else if (type == 'qc') {
        this.userRoleEnglishTitle = 'QC';
        this.userRoleIdForLogin = 10;
        let id = this.userRoleIdForLogin.toString();
        let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
        localStorage.setItem('dash', encryptId);
        this.setTheme('red');
        this.$router.push({ name: 'qcDashboard' });
      } else if (type == 'amar') {
        this.userRoleEnglishTitle = 'statistic';
        this.userRoleIdForLogin = 11;
        let id = this.userRoleIdForLogin.toString();
        let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
        localStorage.setItem('dash', encryptId);
        this.setTheme('red');
        this.$router.push({ name: 'amarDashboard' });
      } else if (type == 'otherOrgan') {
        this.userRoleEnglishTitle = 'OtherOrganization';
        this.userRoleIdForLogin = 12;
        let id = this.userRoleIdForLogin.toString();
        let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
        localStorage.setItem('dash', encryptId);
        this.setTheme('red');
        this.$router.push({ name: 'otherOrganizationMissions' });
      } else if (type == 'eoc') {
        this.userRoleEnglishTitle = 'EOC';
        this.userRoleIdForLogin = 14;
        let id = this.userRoleIdForLogin.toString();
        let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
        localStorage.setItem('dash', encryptId);
        this.setTheme('red');
        // const routeData = this.$router.resolve({ name: 'currentMissionEoc' });
        // window.open(routeData.href, '_blank');
        this.$router.push({ name: 'currentMissionEoc' });
      } else if (type == 'dashboards') {
        this.userRoleEnglishTitle = 'Dashboards';
        this.userRoleIdForLogin = 15;
        let id = this.userRoleIdForLogin.toString();
        let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
        localStorage.setItem('dash', encryptId);
        this.setTheme('red');
        this.$router.push({ name: 'dashboards_115' });
      }
    },
    confirmedExtension: function (extension) {
      this.setExtensionFunction(extension);
    },
    confirmedZone: function (zone) {
      this.setZoneFunction(zone);
    },
    checkForLoginUser: function () {
      if (this.userRoleEnglishTitle == 'User115') {
        let id = this.userRoleIdForLogin.toString();
        let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
        localStorage.setItem('dash', encryptId);
        this.setTheme('red');
        this.$router.push({ name: 'dashboard115' });
      } else if (this.userRoleEnglishTitle == 'User800') {
        this.pageType = 'zone';
        this.getAllZones();
      } else if (this.userRoleEnglishTitle == 'Admission') {
        let id = this.userRoleIdForLogin.toString();
        let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
        localStorage.setItem('dash', encryptId);
        this.setTheme('red');
        this.$router.push({ name: 'admissionMap' });
        // const routeData = this.$router.resolve({ name: 'dashboardAdmission' });
        const routeData = this.$router.resolve({ name: 'admissionMissions' });
        window.open(routeData.href, '_blank');
      } else if (this.userRoleEnglishTitle == 'FollowUp') {
        let id = this.userRoleIdForLogin.toString();
        let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
        localStorage.setItem('dash', encryptId);
        this.setTheme('red');
        this.$router.push({ name: 'dashboardFollowUp' });
      } else if (this.userRoleEnglishTitle == 'Doctor') {
        let id = this.userRoleIdForLogin.toString();
        let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
        localStorage.setItem('dash', encryptId);
        this.setTheme('red');
        this.$router.push({ name: 'doctorDashboard' });
      } else if (this.userRoleEnglishTitle == 'QC') {
        let id = this.userRoleIdForLogin.toString();
        let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
        localStorage.setItem('dash', encryptId);
        this.setTheme('red');
        this.$router.push({ name: 'qcDashboard' });
      } else if (this.userRoleEnglishTitle == 'statistic') {
        let id = this.userRoleIdForLogin.toString();
        let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
        localStorage.setItem('dash', encryptId);
        this.setTheme('red');
        this.$router.push({ name: 'amarDashboard' });
      } else if (this.userRoleEnglishTitle == 'EOC') {
        this.pageType = 'zone';
        this.getAllZones();
      }
    },
    checkForLogin800User: function () {
      let id = this.userRoleIdForLogin.toString();
      let encryptId = CryptoJS.AES.encrypt(id, 'f9rr8Y2D96Klh87N').toString();
      localStorage.setItem('dash', encryptId);
      this.setTheme('red');
      const routeData = this.$router.resolve({ name: 'dashboard800' });
      window.open(routeData.href, '_blank');
      this.$router.push({ name: 'dispatchMap' });
    },
    setTheme: function () {
      let theme = localStorage.getItem('theme');
      if (theme) {
        if (theme == 'blue') {
          localStorage.setItem('darkColor', '#04468B');
          localStorage.setItem('lightColor', '#0A6ADA');
          localStorage.setItem('iconColor', '#0A6ADA');
          localStorage.setItem('background', '#F6FBFF');
          localStorage.setItem('textLightColor', '#4173a8');
          localStorage.setItem('modalBorder', '#04468B');
          localStorage.setItem('oneFieldcolor', '#81A3C5');
          localStorage.setItem('newCallEffect', '#70B2FF');
          this.$vuetify.theme.currentTheme.darkColor = '#04468B';
          this.$vuetify.theme.currentTheme.lightColor = '#0A6ADA';
          this.$vuetify.theme.currentTheme.iconColor = '#0A6ADA';
          this.$vuetify.theme.currentTheme.background = '#F6FBFF';
          this.$vuetify.theme.currentTheme.textLightColor = '#4173a8';
          this.$vuetify.theme.currentTheme.modalBorder = '#04468B';
          this.$vuetify.theme.currentTheme.oneFieldcolor = '#81A3C5';
          this.$vuetify.theme.currentTheme.newCallEffect = '#70B2FF';
        }
      } else {
        localStorage.setItem('theme', 'blue');
        localStorage.setItem('darkColor', '#04468B');
        localStorage.setItem('lightColor', '#0A6ADA');
        localStorage.setItem('iconColor', '#0A6ADA');
        localStorage.setItem('background', '#F6FBFF');
        localStorage.setItem('textLightColor', '#4173a8');
        localStorage.setItem('modalBorder', '#04468B');
        localStorage.setItem('oneFieldcolor', '#81A3C5');
        localStorage.setItem('newCallEffect', '#70B2FF');
        this.$vuetify.theme.currentTheme.darkColor = '#04468B';
        this.$vuetify.theme.currentTheme.lightColor = '#0A6ADA';
        this.$vuetify.theme.currentTheme.iconColor = '#0A6ADA';
        this.$vuetify.theme.currentTheme.background = '#F6FBFF';
        this.$vuetify.theme.currentTheme.textLightColor = '#4173a8';
        this.$vuetify.theme.currentTheme.modalBorder = '#04468B';
        this.$vuetify.theme.currentTheme.oneFieldcolor = '#81A3C5';
        this.$vuetify.theme.currentTheme.newCallEffect = '#70B2FF';
      }
      this.$root.$refs.appView.themConfig();
    },
  },
};
